"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var getReturns_1 = require("../queries/getReturns");
var cancelReturn_1 = require("../mutations/cancelReturn");
var emailReturnLabel_1 = require("../mutations/emailReturnLabel");
var crumb_nav_1 = __importDefault(require("../../account-v3/components/crumb_nav"));
var api_1 = require("../api");
var react_query_1 = require("react-query");
var format_price_1 = __importDefault(require("../../../utils/format-price"));
var classnames_1 = __importDefault(require("classnames"));
var app_1 = require("../app");
var inline_loader_1 = __importDefault(require("../../account-v3/components/inline_loader"));
var loading_modal_1 = __importDefault(require("../../account-v3/components/loading_modal"));
var RMA_STATUS_TEXT = {
    created: 'Created',
    started: 'Waiting for shipment',
    cancelled: 'Cancelled',
    shipped: 'In transit',
    received: 'Processing',
    completed: 'Completed',
    review: 'Processing',
    offer_accepted: 'Processing',
    auto_completed: 'Created',
};
exports.default = (function () {
    var queryClient = (0, react_query_1.useQueryClient)();
    var _a = (0, react_query_1.useQuery)(app_1.QueryKey.GET_RETURNS, function () { return (0, api_1.getSublessAPIClient)().request(getReturns_1.GET_RETURNS); }), data = _a.data, isLoading = _a.isLoading;
    var context = (0, react_1.useContext)(app_1.NewReturnContext);
    var rmas = data === null || data === void 0 ? void 0 : data.account.returns;
    var _b = (0, react_query_1.useMutation)("cancelReturn", function (variables) { return (0, api_1.getSublessAPIClient)().request(cancelReturn_1.CANCEL_RETURN, variables); }, {
        onSuccess: function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, queryClient.invalidateQueries(app_1.QueryKey.GET_RETURNS)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
    }), cancelReturn = _b.mutateAsync, cancelReturnError = _b.error, isCancelReturnLoading = _b.isLoading;
    var _c = (0, react_query_1.useMutation)(app_1.QueryKey.MUTATION_EMAIL_RETURN_LABEL, function (variables) { return (0, api_1.getSublessAPIClient)().request(emailReturnLabel_1.EMAIL_RETURN_LABEL, variables); }), emailReturnLabelMutation = _c.mutateAsync, emailReturnLabelError = _c.error, isEmailReturnLabelLoading = _c.isLoading;
    var handleCancelReturn = function (rmaId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    console.debug(rmaId);
                    if (!confirm('Are you sure?')) return [3 /*break*/, 2];
                    return [4 /*yield*/, cancelReturn({ id: rmaId })];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var emailReturnLabel = function (rmaId) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, emailReturnLabelMutation({ id: rmaId })];
                case 1:
                    result = _a.sent();
                    if (result === null || result === void 0 ? void 0 : result.account_emailReturnLabel) {
                        alert("We have sent you an email with the return label.");
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    return (react_1.default.createElement("div", { className: 'padding-bottom-3 return-container' },
        react_1.default.createElement(crumb_nav_1.default, { current: 'Returns' }),
        react_1.default.createElement("div", { className: 'padding-left-4 padding-right-4 margin-top-10' },
            react_1.default.createElement("div", { className: 'margin-top-2 margin-bottom-4' },
                react_1.default.createElement(react_router_dom_1.Link, { className: 'saveButton display-block text-center', to: "/returns/new/selectItems", onClick: function () {
                        queryClient.refetchQueries('eligibleReturnOrders');
                        context === null || context === void 0 ? void 0 : context.returnComplete();
                    } }, "Initiate a Return")),
            react_1.default.createElement(inline_loader_1.default, { isLoading: isLoading }),
            react_1.default.createElement(loading_modal_1.default, { isLoading: isCancelReturnLoading || isEmailReturnLabelLoading, error: cancelReturnError || emailReturnLabelError, loadingText: isEmailReturnLabelLoading ? 'Sending Return Label Email' : 'Cancelling Return' }),
            rmas && (react_1.default.createElement("div", { className: 'margin-top-6' }, rmas.map(function (rma) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)({ 'account-return-panel': true, cancelled: rma.status === 'cancelled' }), key: rma.id },
                react_1.default.createElement("h6", null,
                    "Return #",
                    rma.rmaNumber),
                react_1.default.createElement("p", { className: 'margin-bottom-2' },
                    "Order Number",
                    rma.orderNumbers.split(',').length > 1 ? 's' : '',
                    ":",
                    react_1.default.createElement("span", { className: 'font-lighter' }, rma.orderNumbers)),
                react_1.default.createElement("p", { className: 'margin-bottom-2' },
                    "Status: ",
                    react_1.default.createElement("span", { className: 'font-lighter' }, RMA_STATUS_TEXT[rma.status]),
                    rma.status === 'started' && (react_1.default.createElement(react_1.default.Fragment, null,
                        "\u00A0\u00A0\u00A0",
                        react_1.default.createElement("a", { className: 'link-wisteria font-lighter font-size-small float-right', onClick: function () { return emailReturnLabel(rma.id); } }, "Email Label")))),
                rma.status !== 'cancelled' && (react_1.default.createElement("p", { className: 'margin-bottom-2' },
                    "Total Refund:",
                    ' ',
                    react_1.default.createElement("span", { className: 'font-lighter' },
                        rma.refundStatus === 'issued' && 'Issued ',
                        (0, format_price_1.default)(rma.totalAmount)))),
                rma.items.map(function (item) {
                    var _a;
                    return (react_1.default.createElement("div", { key: item.id, className: 'media-object margin-bottom-1 font-size-small font-lighter' },
                        react_1.default.createElement("div", { className: 'media-object-section align-self-top' },
                            react_1.default.createElement("div", { className: 'return-item-img-container margin-left-4 margin-right-3' }, item.imgSrc && react_1.default.createElement("img", { src: item.imgSrc }))),
                        react_1.default.createElement("div", { className: 'media-object-section main-section align-self-top font-size-small font-lighter position-relative' },
                            react_1.default.createElement("div", { className: 'float-right margin-left-1' },
                                "Qty: ",
                                item.quantity),
                            react_1.default.createElement("div", { className: 'margin-bottom-2' },
                                ((_a = item.variant.product) === null || _a === void 0 ? void 0 : _a.title) || item.variant.title,
                                item.variant.option1 && (react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("br", null),
                                    react_1.default.createElement("span", { className: 'text-brownish-grey' },
                                        item.variant.option1,
                                        " ",
                                        item.variant.option2 ? " / ".concat(item.variant.option2) : '')))))));
                }),
                ['created', 'started'].includes(rma.status) && (react_1.default.createElement("a", { className: 'display-block text-center margin-top-2 link-wisteria', onClick: function () { return handleCancelReturn(rma.id); } }, "Cancel Return")))); }))))));
});
